import { render, staticRenderFns } from "./UserCardLoading.vue?vue&type=template&id=40a6d884&scoped=true&"
import script from "./UserCardLoading.vue?vue&type=script&lang=ts&"
export * from "./UserCardLoading.vue?vue&type=script&lang=ts&"
import style0 from "./UserCardLoading.vue?vue&type=style&index=0&id=40a6d884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6d884",
  null
  
)

export default component.exports